import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleSelectionService {
  private subject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor() {}

  setSelectedRole = (selectedRole: string) => {
    this.subject.next(selectedRole);
    sessionStorage.setItem('selectedRole', selectedRole);
  };

  getSelectedRole = (): Observable<string> => this.subject.asObservable();

  getSelectedRoleValue(): string {
    return this.subject.getValue();
  }
}
